import classNames from "classnames";
import * as boxStyles from "@app/components/Box/Box.module.scss";
import Icon from "@app/components/Icon";
import * as React from "react";

const SelectButton = ({ headline, className, onClick }) => {
	const boxClassName = classNames({
		[boxStyles["box"]]: true,
		[boxStyles["select-box"]]: true,
		[className]: !!className,
		"align-items-center": true,
	});

	return (
		<div className={boxClassName} onClick={onClick}>
			<span className={boxStyles["title"]} dangerouslySetInnerHTML={{ __html: headline }} />
			<Icon icon={"arrow-right"} size={20} className={boxStyles["arrow"]} />
		</div>
	);
};
export default SelectButton;
